import { render } from "./servicesComponent.vue?vue&type=template&id=7f9d3bf6&scoped=true"
import script from "./servicesComponent.vue?vue&type=script&lang=js"
export * from "./servicesComponent.vue?vue&type=script&lang=js"

import "./servicesComponent.vue?vue&type=style&index=0&id=7f9d3bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9d3bf6"]])

export default __exports__